import { useMemo } from 'react'
import useSocieteCampaign from './useSocieteCampaign'
import { LEBT_SOCIETE_CAMPAIGN_SLUG } from 'loyalty/constants/loyaltyRoutes'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

interface SocieteCampaignTargetTier {
  isSingleTier: boolean
  targetTier: App.LoyaltyTier
  targetTierDisplayName: string
}

function useSocieteCampaignTargetTier(slug: string = LEBT_SOCIETE_CAMPAIGN_SLUG): SocieteCampaignTargetTier {
  const campaign = useSocieteCampaign(slug)

  return useMemo(() => {
    const isSingleTier = campaign?.tiers.length === 1
    const targetTier = isSingleTier ? campaign?.tiers[0] : 'silver' // Default to silver tier if no campaign or single tier
    return {
      isSingleTier,
      targetTier,
      targetTierDisplayName: getLoyaltyTierDisplayName(targetTier),
    }
  }, [campaign])
}

export default useSocieteCampaignTargetTier
